import React from 'react'

export type AgTechFormRowProps = {
    children: React.ReactNode,
    classes?: string
}

export const AgTechFormRow = (props: { children: React.ReactNode, classes?: string }) => {
    return (
        <div className={`wide wrappable py-3 gap-y-5 gap-x-5 flex ${props.classes ?? ''}`}>
            {props.children}
        </div>
    );
}